module.exports = __webpack_public_path__ + "img/brownie.be5030ca.webp";